<template>
    <div class="card-background rounded-lg">
        <h3>{{ title }}</h3>
        <div v-if="data != null && data.length > 0">
            <v-list style="background-color: #e7ff6e;">
                <v-list-item v-for="(record, index) in data" :key="index" class="rounded-lg">
                    <v-row no-gutters class="w-100" style="background-color: white; color: black; border-radius: 8px;" >
                        <!-- Anomaly Information on the Left (col-9) -->
                        <v-col cols="9">
                                {{ record.key }}
                        </v-col>        
                        <v-col cols="3">
                            {{ record.value }}
                        </v-col>                       
                    </v-row>
                </v-list-item>
            </v-list>
        </div>
    </div>
</template>

<script>

export default {
    name: 'KeyValuePairCard',
    props: {
      title: {
        type: String,
        default: ""
      },
      dataFetcher:{
        type: Function,
        default: null       
      }
    },
    data() {
      return {
        data: [],
      };
    },
    async mounted() {
      try {
        if (this.dataFetcher != null){
          this.data = await this.dataFetcher();
        }        
      } catch (error) {
        console.error(`Error fetching data for ${this.title}`, error);
      }
    },
}

</script>
<style scoped>

.card-background {
    background-color: #e7ff6e;
    color: #25333a;
}

</style>